module.exports = __webpack_public_path__ + "static/media/lost_connection.b0a98f42.png";